import React, { useEffect, useState } from "react";
import SuccessModal from "../SuccessModal";
import { Button } from "primereact/button";
import { InputText } from "primereact/inputtext";
import { Dialog } from "primereact/dialog";
import { getStoreLocalData } from "../../utils/localStorage";

const AdditionalInfoChargesEdit = ({
  additionalInfoChargesEditModalVisible,
  setAdditionalInfoChargesEditModalVisible,
  sendDataToAdditionalInfoChargesEdit,
  storeId,
  chargeAmountPreviousValue,
  enabledAmountRoundOff
}) => {

  const { storeLocalData } = getStoreLocalData();
  const [customChargeValue, setCustomChargeValue] = useState("");
  const [customChargeValueTotal, setCustomChargeValueTotal] = useState("");
  const [customChargeCountValue, setCustomChargeCountValue] = useState("1");

  const isRoundOffMode = enabledAmountRoundOff === 0;

  const inputRegex = isRoundOffMode
    ? /^\d*$/
    : new RegExp(`^\\d*\\.?\\d{0,${enabledAmountRoundOff}}$`);

  useEffect(() => {
    // Check if selectedPackageItemValue is available
    const roundOffValue = chargeAmountPreviousValue?.amount?.toFixed(0);
    setCustomChargeValue(roundOffValue?.toString());
    setCustomChargeValueTotal(roundOffValue?.toString());
  }, [chargeAmountPreviousValue]);

  const [modalVisible, setModalVisible] = useState(false);
  const [modalStatus, setModalStatus] = useState(false);
  const [modalText, setModalText] = useState("");
  const [errorText, setErrorText] = useState("");

  const [isSubmitButtonPressed, setIsSubmitButtonPressed] = useState(false);
  const [showUpdateButton, setShowUpdateButton] = useState(false);

  const handleChargeAmountChange = (text) => {

    if (text === "") {
      setCustomChargeValue("");
       
        setErrorText("Please Enter Receive Amount");
      return;
    }

    if (!isRoundOffMode && text === ".") {
      setCustomChargeValue(".");
      return;
    }

    if (!inputRegex.test(text)) return;

    const numericValue = parseFloat(text);

    const finalValue = isRoundOffMode ? String(Math.round(numericValue)) : text;


    if (!text) {
      setCustomChargeValue("");
      setErrorText("Total cannot be empty or zero");
      setIsSubmitButtonPressed(true);
    }
    //  else if (parseInt(text) > parseInt(chargeAmountPreviousValue?.amount)) {
    //   setErrorText(
    //     "Entered Value Can Not Be Greater Then " +
    //       chargeAmountPreviousValue?.amount?.toFixed(0)
    //   );
    //   setCustomChargeValue(text);
    //   setIsSubmitButtonPressed(true);
    // }
    else {
      const newChargeValue = Number(finalValue) * Number(customChargeCountValue);
      setCustomChargeValue(finalValue);
      setCustomChargeValueTotal(newChargeValue);
      setErrorText("");
      setIsSubmitButtonPressed(false);
    }
  };

  const handleChargeCountChange = (text) => {
    if (!text) {
      setCustomChargeCountValue("");
      setErrorText("Charge Count cannot be empty or zero");
      setIsSubmitButtonPressed(true);
    } else if (parseInt(text) <= parseInt(0)) {
      setErrorText("Count Can't Be Less Then Or Equal to Zero");
      setCustomChargeCountValue(text);
      setIsSubmitButtonPressed(true);
    } else {
      setCustomChargeCountValue(text);
      const newChargeValue = parseInt(text) * Number(Number(customChargeValue)?.toFixed(enabledAmountRoundOff));
      // parseInt(chargeAmountPreviousValue?.amount?.toFixed(0));
      // customChargeValue,
      setCustomChargeValueTotal(newChargeValue);
      setErrorText("");
      setIsSubmitButtonPressed(false);
    }
  };

  const handleConfirmation = () => {
    if (!errorText) {
      setIsSubmitButtonPressed(true);
      sendDataToAdditionalInfoChargesEdit({
        success: true,
        customChargeValue: {
          ...chargeAmountPreviousValue,
          amount: Number(Number(customChargeValueTotal)?.toFixed(enabledAmountRoundOff)),
          count: parseInt(customChargeCountValue).toFixed(0),
          chargeDiscountAmount: Number(
            chargeAmountPreviousValue?.amount?.toFixed(enabledAmountRoundOff)
          ),
        },
      });
      setIsSubmitButtonPressed(false);
      setAdditionalInfoChargesEditModalVisible(false);
      setCustomChargeCountValue("1");
    }
    setShowUpdateButton(true);
  };

  const handleModalClose = () => {
    setIsSubmitButtonPressed(false);
    sendDataToAdditionalInfoChargesEdit({
      success: true,
      customChargeValue: {
        ...chargeAmountPreviousValue,
        amount: Number(chargeAmountPreviousValue?.amount?.toFixed(enabledAmountRoundOff)),
        count: parseInt(customChargeCountValue).toFixed(0),
        chargeDiscountAmount: Number(
          chargeAmountPreviousValue?.amount?.toFixed(enabledAmountRoundOff)
        ),
      },
    });
    setCustomChargeCountValue("1");
    setAdditionalInfoChargesEditModalVisible(
      !additionalInfoChargesEditModalVisible
    );
    setErrorText("");
    setShowUpdateButton(false);
  };

  return (
    <div className="flex justify-content-center">
      <Dialog
        modal
        visible={additionalInfoChargesEditModalVisible}
        style={{ width: "50vw" }}
        onHide={() => {
          if (!additionalInfoChargesEditModalVisible) return;
          handleModalClose();
        }}
        content={({ hide }) => (
          <div
            className="flex flex-column gap-4 "
            style={{
              borderRadius: "12px",
              backgroundColor: "#fff",
            }}
          >
              <div>
                <div
                  className="flex border-round-xl  justify-content-between align-items-center gap-2 px-4 py-2"
                  style={{
                    backgroundImage:
                      "radial-gradient(circle at left top, #2B70D7, #1752AA)",
                  }}
                >
                  <div></div>

                  <p className=" text-4xl text-primary-50 font-semibold">
                    Charge Amount
                  </p>
                  <Button
                    label="x"
                    onClick={(e) => hide(e)}
                    text
                    className=" text-2xl text-primary-50 border-1 border-white-alpha-30 hover:bg-white-alpha-10"
                  ></Button>
                </div>

                <div className="mt-3 mx-4">
                  <div className="flex flex-row justify-content-between">
                    <div>
                      <p className=" text-xl font-semibold">Charge</p>
                    </div>
                    <div>
                      <p className=" text-xl font-semibold">Count</p>
                    </div>
                    <div>
                      <p className=" text-xl font-semibold">Total</p>
                    </div>
                  </div>
                </div>
                <div className="mt-1 mb-2 mx-4">
                  <div className="flex flex-row justify-content-between gap-4">
                    <div>
                      <InputText
                        placeholder="Amount"
                        value={customChargeValue}
                        maxLength={50}
                        onChange={(e) =>
                          handleChargeAmountChange(e.target.value)
                        }
                        keyFilter={isRoundOffMode ? "int" : /[\d.]/}
                        className="w-5 bg-white-alpha-20 border-round-lg px-3 text-md "
                      ></InputText>
                    </div>

                    <div>
                      <InputText
                        placeholder="Count"
                        value={customChargeCountValue}
                        maxLength={50}
                        onChange={(e) =>
                          handleChargeCountChange(e.target.value)
                        }
                        className="w-5 bg-white-alpha-20 border-round-lg  px-3 text-md "
                      ></InputText>
                    </div>

                    <div className="flex justify-content-center align-items-center">
                      <p className=" text-xl font-semibold">
                      {storeLocalData?.currencySymbol}{customChargeValueTotal}
                      </p>
                    </div>
                  </div>
                </div>

                {errorText && (
                  <div
                    style={{
                      marginTop: 2,
                      marginBottom: 10,
                      alignSelf: "center",
                    }}
                  >
                    <p style={{ color: "red" }}>{errorText}</p>
                  </div>
                )}
              </div>

              <Button
                disabled={isSubmitButtonPressed}
                onClick={handleConfirmation}
                className="mt-1 mb-3 mx-4 border-round-xl "
              >
                <p className=" w-full text-2xl  font-semibold flex justify-content-center">
                  Update
                </p>
              </Button>
          </div>
        )}
      ></Dialog>
      <SuccessModal
        modalVisible={modalVisible}
        setModalVisible={setModalVisible}
        status={modalStatus}
        text={modalText}
      />
    </div>
  );
};

export default AdditionalInfoChargesEdit;
